import { DesignerTab, PROFILE_TABS_SUBSCRIBE } from "shared/constants/designerTab";
import { ADDITIONAL_TABS_SIGN } from "../components/designerSliderItem";

export const  getCalculatedTab = (currentTab: string, currentAdditionalTab: string, counts: any) => {
    const result: Record<string, string> = { 
      mainTab: currentTab, 
      additionalTab: currentAdditionalTab 
    };

    if (currentTab === ADDITIONAL_TABS_SIGN) {
      const authorTab = counts[DesignerTab.workingMaterialsAuthor] > 0
        ? DesignerTab.workingMaterialsAuthor : null
      const coAuthorTab = counts[DesignerTab.workingMaterialsCoauthor] > 0 
        ? DesignerTab.workingMaterialsCoauthor : null
      const defaultTab = DesignerTab.workingMaterialsStudents;

      result.additionalTab = (currentAdditionalTab || authorTab || coAuthorTab || defaultTab)
    }

    if (currentTab === DesignerTab.subscribe) {
      const subscribersTab = counts[DesignerTab.subscriptions as keyof {}] > 0
        ? DesignerTab.subscriptions  : null

      const defaultTab = PROFILE_TABS_SUBSCRIBE?.find((v) => {
        return counts[v] > 0
      }) || ''

      result.additionalTab = (currentAdditionalTab || subscribersTab || defaultTab)
    }

    return result
  }import { DesignerTab, PROFILE_TABS_SUBSCRIBE } from "shared/constants/designerTab";
import { ADDITIONAL_TABS_SIGN } from "../components/designerSliderItem";

export const  getCalculatedTab = (currentTab: string, currentAdditionalTab: string, counts: any) => {
    const result: Record<string, string> = { 
      mainTab: currentTab, 
      additionalTab: currentAdditionalTab 
    };

    if (currentTab === ADDITIONAL_TABS_SIGN) {
      const authorTab = counts[DesignerTab.workingMaterialsAuthor] > 0
        ? DesignerTab.workingMaterialsAuthor : null
      const coAuthorTab = counts[DesignerTab.workingMaterialsCoauthor] > 0 
        ? DesignerTab.workingMaterialsCoauthor : null
      const defaultTab = DesignerTab.workingMaterialsStudents;

      result.additionalTab = (currentAdditionalTab || authorTab || coAuthorTab || defaultTab)
    }

    if (currentTab === DesignerTab.subscribe) {
      const subscribersTab = counts[DesignerTab.subscriptions as keyof {}] > 0
        ? DesignerTab.subscriptions  : null

      const defaultTab = PROFILE_TABS_SUBSCRIBE?.find((v) => {
        return counts[v] > 0
      }) || ''

      result.additionalTab = (currentAdditionalTab || subscribersTab || defaultTab)
    }

    return result
  }